/**
 * 通知类型枚举
 */
export enum NotificationType {
  /** 邀约通知 - 向嘉宾发送参会邀约 */
  INVITATION = 'INVITATION',
  /** 报名确认通知 - 嘉宾确认参会后发送 */
  REGISTRATION_CONFIRM = 'REGISTRATION_CONFIRM',
  /** 议程提醒 - 议程开始前提醒嘉宾 */
  AGENDA_REMINDER = 'AGENDA_REMINDER',
  /** 议程变更通知 - 议程发生变更时通知嘉宾 */
  AGENDA_CHANGE = 'AGENDA_CHANGE',
  /** 接送安排通知 - 接送服务信息通知 */
  PICKUP = 'PICKUP',
  /** 公告通知 - 大会公告/通知 */
  ANNOUNCEMENT = 'ANNOUNCEMENT',
  /** 签到提醒 - 签到时间提醒 */
  CHECKIN_REMINDER = 'CHECKIN_REMINDER',
}

/** 所有通知类型值的数组 */
export const NotificationTypeValues: string[] = Object.values(NotificationType);

/** 通知类型中文标签映射 */
export const NotificationTypeLabels: Record<NotificationType, string> = {
  [NotificationType.INVITATION]: '邀约通知',
  [NotificationType.REGISTRATION_CONFIRM]: '报名确认',
  [NotificationType.AGENDA_REMINDER]: '议程提醒',
  [NotificationType.AGENDA_CHANGE]: '议程变更',
  [NotificationType.PICKUP]: '接送安排',
  [NotificationType.ANNOUNCEMENT]: '公告通知',
  [NotificationType.CHECKIN_REMINDER]: '签到提醒',
};
